import type { ActivationFilter } from "../../../../api/useActivationFilters";

export enum FilterProperties {
  QUANTITY = "quantity",
  MAXIMUM_STD = "maximumStd",
  MAXIMUM_VALUE = "maximumValue",
  MINIMUN_VALUE = "minimumValue",
}

export const filterColumns = [
  FilterProperties.QUANTITY,
  FilterProperties.MAXIMUM_STD,
  FilterProperties.MINIMUN_VALUE,
  FilterProperties.MAXIMUM_VALUE,
] as const;
export type FilterColumn = (typeof filterColumns)[number];

export type ParsedFilter = ActivationFilter & {
  unit: string | null;
  name: string | null;
};

// Backwards compatibility
export enum ImportVersionsEnum {
  lithium = "lithium",
  helium = "helium",
}
export const expectedQuantityFormatLithium = [
  "quantity",
  "minimumValue",
  "maximumValue",
  "maximumStd",
] as const;
export type QuantityColumnsLithium = (typeof expectedQuantityFormatLithium)[number];
export const expectedQuantityFormatHelium = [
  "technicalName",
  "filterType",
  "filterFormula",
  "filterMin",
  "filterMax",
] as const;
export type QuantityColumnsHelium = (typeof expectedQuantityFormatHelium)[number];
export const CSVColumnMappingHelium = new Map<QuantityColumnsLithium, QuantityColumnsHelium[]>();
CSVColumnMappingHelium.set("quantity", ["technicalName"]);
CSVColumnMappingHelium.set("minimumValue", ["filterMin"]);
CSVColumnMappingHelium.set("maximumValue", ["filterMax"]);
CSVColumnMappingHelium.set("maximumStd", ["filterMax"]);
